import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { FormaPagamentoResponse } from '../../responses/financas/forma-pagamento.response';
import { FormaPagamentoRequest } from '../../requests/financas/forma-pagamento.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class FormaPagamentoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'FormaPagamento';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<FormaPagamentoResponse> {
        return this.httpClient
            .get<FormaPagamentoResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(idFormaPagamento: number, request: FormaPagamentoRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idFormaPagamento/${idFormaPagamento}`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
